module.exports = __webpack_public_path__ + "static/media/Y2.df2a5b62.png";